import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
// import { useQuery } from "@tanstack/react-query";

import { useToastContext } from "../../../modules/toast/context";
import { useApi } from "../../../hooks/api/useApi";
import { useThemeChange } from "../../../utils/themeChange";
import { INQUIRIES } from "../../../constants/api-constants";

import Loading from "../../../components/components/Loading";
import ArtCard from "../../components/artCard";
// import SingleSelect from "../../components/singleSelect";

const { ADD_INQUIRY } = INQUIRIES;
// const { LIST_LICENSE_TYPES } = LICENSE_TYPES;

const Inquiry = () => {
  const themeChange = useThemeChange();
  const { showError, showSuccess } = useToastContext();
  const { post } = useApi();
  const location = useLocation();
  const navigate = useNavigate();

  const artDetail = location?.state?.artDetail;

  // const licenseType = artDetail?.licenseTypes?.map((data, index) => ({
  //   label: data,
  //   value: index,
  // }));

  // const [selectedLicense, setSelectedLicense] = useState(null);

  const postInquiry = useMutation({
    mutationFn: post,
    onSuccess: () => {
      showSuccess("Inquiry submission successfull.");
      navigate(-1);
    },
    onError: () => {
      showError("Inquiry submission failed.");
    },
  });

  // const onLicenseSelect = (selectedLicense) => {
  //   setSelectedLicense(selectedLicense);
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (!selectedLicense) return showError("Please select license types.");
    postInquiry.mutate({
      ...formik.values,
      artId: artDetail?.id,
      artistId: artDetail?.artistId,
      // notes: e.target.note.value,
      // licenseTypes: [selectedLicense?.label],
      route: ADD_INQUIRY,
    });
  };

  const phoneRegExp =
    /^((\+[1-9]{1,4}[ \\-])|(\([0-9]{2,3}\)[ \\-])|([0-9]{2,4})[ \\-]*)?[0-9]{10}$/;
  const nameRegex = /^[a-zA-Z/\s/]*$/;
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      contact: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .matches(nameRegex, "Invalid Name. Can only contain letters.")
        .required(" required*"),
      email: Yup.string().email(" Invalid Email").required(" required*"),
      contact: Yup.string()
        .matches(phoneRegExp, "Invalid contact number")
        .required("required*"),
    }),
  });

  // const licenseTypes = useQuery({
  //   queryKey: ["license-types"],
  //   queryFn: () => getAll(LIST_LICENSE_TYPES),
  // });

  // const handleDetailClick = (e) => {
  //   e.preventDefault();
  //   const targetUrl = licenseTypes?.data[0]?.pdfLink;
  //   window.open(targetUrl, "_blank");
  // };

  return (
    <div className={themeChange.add("section")}>
      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12">
                <h1 className="text-center">Inquiry Form</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="container">
        <div className="row">
          <div className="col-md-8">
            <form
              name="contactForm"
              id="contact_form"
              className="form-border"
              action="#"
              onSubmit={handleSubmit}
            >
              <div className="row">
                <div className="col-md-12">
                  <div className="field-set">
                    <label htmlFor="name">
                      Name:<span className="error-message-color">*</span>
                    </label>
                    {formik.touched.name && formik.errors.name ? (
                      <span className="error-message-color">
                        {formik.errors.name}
                      </span>
                    ) : null}
                    <input
                      className="form-control"
                      required
                      type="text"
                      name="name"
                      id="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="field-set">
                    <label htmlFor="email">
                      Email Address:
                      <span className="error-message-color">*</span>
                    </label>
                    {formik.touched.email && formik.errors.email ? (
                      <span className="error-message-color">
                        {formik.errors.email}
                      </span>
                    ) : null}
                    <input
                      className="form-control"
                      required
                      type="email"
                      name="email"
                      id="email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="field-set">
                    <label htmlFor="contact">
                      Phone Number:
                      <span className="error-message-color">*</span>
                    </label>
                    {formik.touched.contact && formik.errors.contact ? (
                      <span className="error-message-color">
                        {formik.errors.contact}
                      </span>
                    ) : null}
                    <input
                      className="form-control"
                      required
                      type="text"
                      min={0}
                      name="contact"
                      id="contact"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.contact}
                    />
                  </div>
                </div>
                {/* <div className="col-md-12">
                  <div className="field-set">
                    <label htmlFor="note">Notes:</label>
                    <input
                      type="text"
                      name="note"
                      id="note"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="field-set">
                    <label>
                      License: <span className="error-message-color">*</span>
                    </label>
                    <SingleSelect
                      value={selectedLicense}
                      options={licenseType}
                      handleSelect={onLicenseSelect}
                    />
                  </div>
                  {/* {selectedLicense && (
                    <>
                      <span className="spacer-10" />
                      <div className="d-flex justify-content-end">
                        <button
                          style={{ textTransform: "capitalize" }}
                          id="btn_edit"
                          onClick={handleDetailClick}
                        >
                          License Detail
                        </button>
                      </div>
                    </>
                  )} 
                </div>
                {artDetail?.additionalTerms && (
                  <>
                    <div className="spacer-20"></div>
                    <div className="col-md-12">
                      <div className="field-set">
                        <label>Additional Terms:</label>
                        <input
                          type="text"
                          name="terms"
                          id="terms"
                          className="form-control"
                          value={artDetail?.additionalTerms}
                          disabled
                        />
                      </div>
                    </div>
                  </>
                )} */}
                <div className="spacer-30"></div>
                <div className="col-md-12 mt-4 mb-4">
                  <div id="submit" className="pull-left">
                    {postInquiry.isLoading ? (
                      <Loading loadingMessage="Submitting your inquiry" />
                    ) : (
                      <input
                        type="submit"
                        id="send_message"
                        value="Submit"
                        className="btn btn-main color-2"
                        disabled={!formik.isValid || postInquiry.isLoading}
                      />
                    )}
                  </div>
                  <div className="clearfix"></div>
                </div>
              </div>
            </form>
          </div>
          <div className="col-lg-3 col-sm-6 col-xs-12">
            <ArtCard
              className="d-item"
              name={artDetail?.name}
              previewImage={artDetail?.previewImage}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Inquiry;
